import { memo } from "react";
import { Button, Card, CardActions, CardContent, Chip, Grid2, Switch, TextField, Typography } from "@mui/material";
import { icon } from "@/app/style/icons";

const WesentlichkeitsSettings = memo(() => {
    return (
        <Grid2 container size={12}>
            <Grid2 size={12}>
                <Typography variant={"h4"}>Beschreibung des Unternehmens</Typography>
            </Grid2>

            <Grid2 container size={12} spacing={3}>
                <Grid2 size={12}>
                    <Typography fontSize={"0.95rem"} fontWeight={500}>
                        Dein Firmenprofil:
                    </Typography>
                </Grid2>

                <Grid2 size={12}>
                    <TextField placeholder={"Hier könnte dein Firmenprofil stehen..."} sx={{ outline: "none" }} multiline rows={10} fullWidth />
                    <Typography fontSize={"0.7rem"} align={"right"} sx={{ pr: 1, pt: 0.5 }}>
                        mind. 200 Zeichen
                    </Typography>
                </Grid2>
            </Grid2>

            <Grid2 container size={12} spacing={3}>
                <Grid2 container size={12} spacing={3} height={134}>
                    <Grid2 size={6} height={"inherit"}>
                        <Card sx={{ height: "inherit" }}>
                            <CardContent>Bestehendes Firmenprofil verwenden:</CardContent>

                            <CardActions>
                                <Switch />
                            </CardActions>
                        </Card>
                    </Grid2>

                    <Grid2 size={6} height={"inherit"}>
                        <Card sx={{ height: "inherit" }}>
                            <CardContent sx={{ mb: -0.5 }}>
                                <TextField label={"Unternehmenswebseiten"} fullWidth />
                            </CardContent>

                            <CardActions sx={{ ml: 0.5 }}>
                                <Chip label={"esgbot.ai"} clickable onDelete={() => {}} />
                                <Chip label={"dv-immo.de"} clickable onDelete={() => {}} />
                            </CardActions>
                        </Card>
                    </Grid2>
                </Grid2>

                <Grid2 container size={12} spacing={1.5}>
                    <Grid2 size={12} height={"inherit"}>
                        <Card sx={{ height: "inherit" }}>
                            <CardActions sx={{ ml: 0.5 }}>
                                <Chip label={"DVimmo.pdf"} clickable onDelete={() => {}} />
                                <Chip label={"dv-immo.de"} clickable onDelete={() => {}} />
                            </CardActions>
                        </Card>
                    </Grid2>
                </Grid2>

                <Grid2 container size={12} mt={3} justifyContent={"flex-end"}>
                    <Button variant={"contained"} startIcon={<icon.arrowRight />}>
                        Analyse durchführen
                    </Button>
                </Grid2>
            </Grid2>
        </Grid2>
    );
});

export default WesentlichkeitsSettings;
